import React from 'react';
import { Contact } from './Contact';
import { HeadSection } from './HeadSection';
import { HomeContactTel } from './HomeContactTel';
import { MasterViewPage } from './MasterPage';
import { SeoStuff } from './SeoStuff';


export const Home = () => {
    return <MasterViewPage>
        <HeadSection />
        <div className="dark"><HomeContactTel /></div>
        <Contact />
        <SeoStuff />
    </MasterViewPage >;
};
